import axios from 'CanExConfig/axios'

export const fetchMessages = async (id, params) => {
  const response = await axios(`/api/candidate/interview_requests/${id}/messages`, {
    method: 'get',
    params: {
      paginate: false,
      ...params,
    },
  })

  return response.data
}

export const createMessage = async (id, data) => {
  const response = await axios(`/api/candidate/interview_requests/${id}/messages`, {
    method: 'post',
    data,
  })

  return response.data
}
